import React, { Fragment } from 'react';
import { array, func, object } from 'prop-types';
import { Container, Col, Row } from 'reactstrap';

import ListBox from '@components/ListBox/ListBox';
import TextBox from '@components/TextBox/TextBox';
import ImportImages from '@src/importImages';

const Clouds = ImportImages('/home/clouds.jpg');

const propTypes = {
  activeBox: object.isRequired,
  boxes: array.isRequired,
  handleClick: func.isRequired
};

const Desktop = ({ activeBox, boxes, handleClick, heightSm }) => (
  <Fragment>
    <img src={Clouds} alt={'Slider1'} className={'img-fluid'} />
    <Container
      fluid={true}
      className={'abs-container d-flex align-items-center'}
    >
      <Row className={'w-100 mx-auto align-items-center'}>
        <Col md={{ offset: 1, size: 4 }}>
          <TextBox {...activeBox} isHeader={true} />
        </Col>
        <Col md={{ offset: 1, size: 5 }}>
          <Row className={'justify-content-center'}>
            {boxes.map(box => (
              <ListBox
                activeBox={activeBox.id}
                key={box.id}
                {...box}
                click={() => handleClick(box)}
                heightSm={heightSm}
                colStyles={
                  heightSm
                    ? { marginTop: '0.5rem', marginBottom: '0.5rem' }
                    : {}
                }
              />
            ))}
          </Row>
        </Col>
      </Row>
    </Container>
  </Fragment>
);

Desktop.propTypes = propTypes;

export default Desktop;



// WEBPACK FOOTER //
// ./src/components/Partners/Desktop/Desktop.jsx